<template>
  <div ref="datepickerContainer">
<!--    <b-form-group :label="label">-->
      <b-input-group>
        <b-form-input
          v-model="displayValue"
          class="datepicker-input"
          size="sm"
          type="text"
          readonly
          :placeholder="placeholder"
          @click="showPicker = !showPicker"
        ></b-form-input>
        <b-input-group-append v-if="clearable">
          <b-button size="sm" @click.stop="clearValue">
            <font-awesome-icon icon="times-circle"/>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <b-card
        v-if="showPicker"
        ref="pickerCard"
        class="mt-2 datepicker-card"
      >
        <div class="d-flex justify-content-between align-items-center mb-3">
          <b-button
            variant="outline-primary"
            @click="prevYear"
            :disabled="currentYear <= minYear"
          >&lt;</b-button>
          <h5 class="mb-0">{{ currentYear }}</h5>
          <b-button
            variant="outline-primary"
            @click="nextYear"
            :disabled="currentYear >= maxYear"
          >&gt;</b-button>
        </div>

        <div class="month-grid">
          <b-button
            v-for="(month, index) in months"
            :key="index"
            :variant="isSelected(month, currentYear) ? 'primary' : 'outline-secondary'"
            class="month-button"
            :disabled="isDisabled(month, index)"
            @click="selectMonth(month)"
          >
            {{ month }}
          </b-button>
        </div>
      </b-card>
<!--    </b-form-group>-->
  </div>
</template>

<script>
export default {
  name: "MonthPicker",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Date, String, Object],
      default: null
    },
    label: {
      type: String,
      default: 'Выберите месяц и год'
    },
    placeholder: {
      type: String,
      default: 'Месяц Год'
    },
    minYear: {
      type: Number,
      default: 1900
    },
    maxYear: {
      type: Number,
      default: 2100
    },
    disabledMonths: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPicker: false,
      currentYear: new Date().getFullYear(),
      internalValue: null,
      months: [
        'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
        'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'
      ],
      monthValues: [
        '01', '02', '03', '04', '05', '06',
        '07', '08', '09', '10', '11', '12'
      ]
    };
  },
  computed: {
    displayValue() {
      if (!this.internalValue) return '';
      const date = new Date(this.internalValue);
      return `${this.months[date.getMonth()]} ${date.getFullYear()}`;
    },
    selectedMonthIndex() {
      if (!this.internalValue) return -1;
      const date = new Date(this.internalValue);
      return date.getMonth();
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.internalValue = new Date(newVal);
          this.currentYear = this.internalValue.getFullYear();
        } else {
          this.internalValue = null;
        }
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    prevYear() {
      if (this.currentYear > this.minYear) {
        this.currentYear--;
      }
    },
    nextYear() {
      if (this.currentYear < this.maxYear) {
        this.currentYear++;
      }
    },
    selectMonth(month) {
      const monthIndex = this.months.indexOf(month);
      const newDate = new Date(this.currentYear, monthIndex, 1);
      this.internalValue = newDate;
      this.$emit('change', newDate);
      this.showPicker = false;
    },
    isSelected(month, year) {
      if (!this.internalValue) return false;
      const date = new Date(this.internalValue);
      return this.months[date.getMonth()] === month && date.getFullYear() === year;
    },
    isDisabled(month, monthIndex) {
      // Проверяем, отключен ли месяц в текущем году
      const disabledForYear = this.disabledMonths.some(m => {
        return m.year === this.currentYear && m.months.includes(monthIndex);
      });

      // Проверяем, находится ли год в допустимых пределах
      const yearOutOfRange = this.currentYear < this.minYear || this.currentYear > this.maxYear;

      return disabledForYear || yearOutOfRange;
    },
    handleClickOutside(event) {
      if (
        this.showPicker &&
        !this.$refs.datepickerContainer.contains(event.target) &&
        (!this.$refs.pickerCard || !this.$refs.pickerCard.contains(event.target))
      ) {
        this.showPicker = false;
      }
    },
    clearValue() {
      this.internalValue = null;
      this.$emit('change', null);
    },
    // Методы для программного управления
    setMinYear(year) {
      this.minYear = year;
      if (this.currentYear < year) {
        this.currentYear = year;
      }
    },
    setMaxYear(year) {
      this.maxYear = year;
      if (this.currentYear > year) {
        this.currentYear = year;
      }
    },
    setDisabledMonths(disabledMonths) {
      this.disabledMonths = disabledMonths;
    }
  }
}
</script>

<style scoped>
.month-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
}

.month-button {
  width: 100%;
}

.datepicker-card {
  position: absolute;
  z-index: 2001;
  width: 100%;
  max-width: 300px;
  min-width: 300px;
}

.datepicker-input {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MonthPicker/MonthPicker.vue